import {
  ILicense,
  ILicenseAssignment,
  PagedRequest,
  PagedResponse,
} from '@topshots/core-models';
import { topshotsAPI } from '../../app/api';

const ordersApi = topshotsAPI.injectEndpoints({
  endpoints: (build) => ({
    getLicenses: build.query<
      PagedResponse<ILicense[]>,
      PagedRequest & { includeInactive?: boolean }
    >({
      query: (request) => ({
        url: 'licenses',
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'Licenses' as const,
                id: _id.toString(),
              })),
              { type: 'Licenses', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'Licenses', id: 'PARTIAL-LIST' }],
    }),
    getLicense: build.query<ILicense, string>({
      query: (id) => ({
        url: `licenses/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, page) => [
        { type: 'Licenses' as const, id: result?._id.toString() },
      ],
    }),
    getLicenseAssignments: build.query<
      PagedResponse<ILicenseAssignment[]>,
      PagedRequest & { licenseId: string }
    >({
      query: (request) => ({
        url: `licenses/${request.licenseId}/assignments`,
        method: 'GET',
        params: request,
      }),
      providesTags: (result, error, page) =>
        result
          ? [
              // Provides a tag for each enquiry in the current page,
              // as well as the 'PARTIAL-LIST' tag.
              ...result.data.map(({ _id }) => ({
                type: 'LicenseActivations' as const,
                id: _id.toString(),
              })),
              { type: 'LicenseActivations', id: 'PARTIAL-LIST' },
            ]
          : [{ type: 'LicenseActivations', id: 'PARTIAL-LIST' }],
    }),
  }),
});

export const {
  useGetLicensesQuery,
  useGetLicenseQuery,
  useGetLicenseAssignmentsQuery,
} = ordersApi;
